import React from 'react';

export const ProgressBadge = (props) => (
	<div id="progress-badge">
		<img src={"/images/icons/" + props.value + ".svg"} aria-hidden="true" alt={props.value +" percentage completed"} />
	</div> 
);


// WEBPACK FOOTER //
// ./src/components/ProgressBadge/ProgressBadge.js